<template>
  <v-container grid-list-xl fluid>
    <v-layout>
      <v-flex>
        <v-card>
          <v-card-title>
            <search-field ref="searchRef" @search="search"></search-field>
            <v-spacer></v-spacer>
            <!-- Refresh Button -->
            <refresh-button @refresh="refreshTable()"></refresh-button>

            <confirm-dialog
              :confirmDialog="openConfirmDialog"
              @saveConfirmDialog="approveCommuter()"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            ></confirm-dialog>

            <approval-dialog
              :confirmDialog="openApprovalDialog"
              @saveConfirmDialog="disapproveCommuter()"
              @closeConfirmDialog="closeConfirmDialog"
              :loading="confirmLoading"
            >
              <template>
                <v-radio-group v-model="disapproveOption" color="#00C853">
                  <v-radio
                    label="EXISTING CARDHOLDER"
                    :value="0"
                    color="#00C853"
                  ></v-radio>
                  <v-radio
                    label="INCOMPLETE/INACCURATE INFO"
                    :value="1"
                    color="#00C853"
                  ></v-radio> </v-radio-group
              ></template>
            </approval-dialog>
          </v-card-title>
          <v-divider></v-divider>

          <v-container fluid class="pa-2">
            <v-layout row>
              <v-flex sm4 md4>
                <!-- <v-btn flat @click="openFilterExpansion">
                  <v-icon class="mr-3">
                    {{
                    openFilter ? "keyboard_arrow_up" : "keyboard_arrow_down"
                    }}
                  </v-icon>
                  <span>Filter {{ title }}</span>
                </v-btn>-->
              </v-flex>
              <v-flex sm8 md8>
                <v-container class="py-2 pr-0" fluid>
                  <v-layout row align-center>
                    <v-flex xs12 sm8 md9 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm10 md11 class="px-0">
                          <p
                            class="text-xs-right grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            Row per Page:
                          </p>
                        </v-flex>
                        <v-flex xs6 sm2 md1 class="text-xs-center">
                          <v-layout row align-center>
                            <v-flex xs7 sm12>
                              <v-select
                                style="font-size: 14px;"
                                :items="page"
                                class="grey--text"
                                id="selected"
                                v-model="pageLimit"
                                @input="limitClick"
                                dense
                                height="20px"
                                :disabled="
                                  this.items.length < 10 ? true : false
                                "
                              ></v-select>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs12 sm4 md3 class="py-0">
                      <v-layout row align-center>
                        <v-flex xs6 sm6 class="px-0 pl-3">
                          <p
                            class="text-xs-center grey--text caption"
                            style="font-size: 14px; margin-top: 14px;"
                          >
                            {{ itemFrom + " -" + itemTo + " of " }}
                            {{ totalItems }}
                          </p>
                        </v-flex>
                        <v-flex xs6 sm6>
                          <v-layout row style="padding-right: 100px;">
                            <v-flex sm6 class="mr-3 pl-0">
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="backClick"
                                :disabled="disabledBack"
                              >
                                <v-icon dark>chevron_left</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex sm6>
                              <v-btn
                                fab
                                light
                                small
                                flat
                                @click="nextClick"
                                :disabled="disabledNext"
                              >
                                <v-icon dark>chevron_right</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>
            </v-layout>
          </v-container>

          <v-divider></v-divider>

          <filter-panel :openFilter="openFilter">
            <v-flex md4>
              <v-select
                v-model="filterStatus"
                :items="filterStatuses"
                label="Status"
                solo
                clearable
              ></v-select>
            </v-flex>
          </filter-panel>

          <v-data-table
            :headers="headers"
            :items="items"
            hide-actions
            disable-initial-sort
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable',
                    header.value === queryParams.order ? 'active' : '',
                    'text-xs-' + header.align,
                  ]"
                  @click="header.sortable ? changeSort(header) : ''"
                >
                  {{ header.text }}
                  <v-icon small v-if="header.sortable">
                    {{
                      header.sortNum === 1 ? "arrow_downward" : "arrow_upward"
                    }}
                  </v-icon>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-center">
                {{ props.index + queryParams.offset + 1 }}
              </td>
              <td class="text-xs-left text-uppercase">
                {{
                  props.item.first_name.toUpperCase() +
                    " " +
                    (props.item.middle_name
                      ? props.item.middle_name.toUpperCase()
                      : "") +
                    " " +
                    props.item.last_name
                }}
              </td>

              <td class="text-xs-left text-uppercase">
                {{ props.item.remarks ? props.item.remarks : "--" }}
              </td>

              <td class="text-xs-center">
                {{
                  props.item.date
                    ? $dateFormat(props.item.date, "YYYY-MM-DD hh:mm A")
                    : "--"
                }}
              </td>

              <td class="text-no-wrap text-xs-center">
                <view-button @view="openViewDialog(props.item)"></view-button>
                <v-tooltip top>
                  <v-btn
                    icon
                    slot="activator"
                    v-if="$moduleAccess('same_pre_registered_commuters')"
                    @click="openDuplicateDialog(props.item)"
                  >
                    <v-icon color="blue lighten-2">person_search</v-icon>
                  </v-btn>
                  <span>Same Profile</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    icon
                    slot="activator"
                    v-if="$moduleAccess('approve_pre_registered_commuters')"
                    @click="openApprove(props.item)"
                  >
                    <v-icon color="green">done</v-icon>
                  </v-btn>
                  <span>Approve</span>
                </v-tooltip>
                <v-tooltip top>
                  <v-btn
                    icon
                    slot="activator"
                    v-if="$moduleAccess('disapprove_pre_registered_commuters')"
                    @click="openDisapprove(props.item)"
                  >
                    <v-icon color="red">clear</v-icon>
                  </v-btn>
                  <span>Disapprove</span>
                </v-tooltip>
              </td>
            </template>
          </v-data-table>
          <v-divider></v-divider>
          <v-container class="py-0" fluid>
            <v-layout wrap align-center class="pa-5"></v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>

    <action-dialog
      :type="dialogType"
      :title="'Pre-Registered Commuter'"
      :dialog="dialogStatus"
      @closeDialog="closeViewDialog"
      :loading="dialogLoading"
    >
      <v-container grid-list-xs>
        <v-layout justify-center>
          <v-flex md4>
            <jti-expansion-panel>
              <img :src="viewData.image" height="275" width="275" />
            </jti-expansion-panel>
          </v-flex>
          <v-flex md8>
            <jti-expansion-panel panelName="Pre-Registered Commuter Details">
              <v-form ref="form" lazy-validation>
                <v-layout justify-center>
                  <v-flex md4 class="px-3">
                    <v-text-field
                      v-model="viewData.last_name"
                      label="Last Name"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 class="px-3">
                    <v-text-field
                      v-model="viewData.first_name"
                      label="First Name"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex md4 class="px-3">
                    <v-text-field
                      v-model="viewData.middle_name"
                      label="Middle Name"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-flex md6 class="px-3">
                    <v-text-field
                      v-model="viewData.birth_date"
                      label="Birth Date"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex md6 class="px-3">
                    <v-text-field
                      v-model="viewData.occupation"
                      label="Occupation"
                      type="text"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs12 sm12 md2 lg2 class="px-3">
                    <v-text-field
                      label="St/Bldg/Subd"
                      type="text"
                      v-model="viewData.add_no"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md2 lg2 class="px-3">
                    <v-text-field
                      label="Barangay"
                      type="text"
                      v-model="viewData.barangay"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg3 class="px-3">
                    <v-text-field
                      label="City"
                      type="text"
                      v-model="viewData.city"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md3 lg3 class="px-3">
                    <v-text-field
                      label="Province"
                      type="text"
                      v-model="viewData.province"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md2 lg2 class="px-3">
                    <v-text-field
                      label="Zip Code"
                      type="text"
                      v-model="viewData.zip_code"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout justify-center>
                  <v-flex xs12 sm12 md6 lg6 class="px-3">
                    <v-text-field
                      label="E-mail Address"
                      type="text"
                      v-model="viewData.email"
                      readonly
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md6 lg6 class="px-3">
                    <v-text-field
                      label="Mobile Number (+63)"
                      type="text"
                      v-model="viewData.contact_no"
                      readonly
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-form>
            </jti-expansion-panel>
          </v-flex>
        </v-layout>
      </v-container>
    </action-dialog>

    <customize-dialog
      title="Registered Commuters"
      action="existing"
      color="blue lighten-2"
      :dialog="duplicateDialog"
      @closeDialog="closeViewDialog"
      :loading="dialogLoading"
    >
      <registration-existing :data="duplicateData"> </registration-existing>
    </customize-dialog>
  </v-container>
</template>

<script>
import Services from "@/services/Services";
import RegistrationExisting from "@/components/RegistrationExistingUser";

export default {
  components: {
    RegistrationExisting,
  },
  data() {
    return {
      openFilter: false,
      title: "Pre-Registered Commuters",
      headers: [
        { text: "#", align: "center", sortable: false },
        // Add your Header BELOW
        {
          text: "Name",
          align: "left",
          sortable: false,
        },
        {
          text: "Remarks",
          align: "left",
          sortable: false,
        },
        {
          text: "Registration Date and Time",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ],
      moduleId: "",
      items: [],
      moduleItems: [],
      searchData: "",
      queryParams: {
        search: "",
        limit: 10,
        offset: 0,
      },
      buttonType: "",
      dialogType: "",
      dialogStatus: false,
      openConfirmDialog: false,
      openApprovalDialog: false,
      viewData: {},
      confirmLoading: false,
      dialogLoading: false,
      totalItems: 0,
      itemFrom: 0,
      itemTo: 0,
      disabledNext: false,
      disabledBack: true,
      page: [
        { text: 10, value: 10 },
        { text: 20, value: 20 },
        { text: 30, value: 30 },
        { text: 40, value: 40 },
        { text: 50, value: 50 },
      ],
      filterStatuses: [
        {
          text: "APPROVED",
          value: 1,
        },
        {
          text: "DISAPPROVED",
          value: 2,
        },
      ],
      filterStatus: null,
      disapproveOption: 0,
      duplicateDialog: false,
      duplicateData: {},
    };
  },
  created: function() {
    this.getData();
  },
  computed: {
    pageLimit: {
      get() {
        return 10;
      },
      set(val) {
        this.queryParams.limit = val;
        this.queryParams.offset = 0;
      },
    },
  },
  watch: {
    filterStatus: async function() {
      if (
        this.filterStatus !== null &&
        this.filterStatus !== undefined &&
        this.filterStatus !== ""
      ) {
        this.queryParams.offset = 0;
        this.queryParams.status = this.filterStatus;
        this.getData();
      } else {
        this.queryParams.offset = 0;
        this.queryParams.status = null;
        this.getData();
      }
    },
  },
  methods: {
    search(data) {
      this.queryParams.search = data;
      this.queryParams.offset = 0;
      this.queryParams.limit = 10;
      this.getData();
    },
    async getData() {
      // Start Loading
      this.$clearInfoBar();
      this.items = [];
      this.$store.dispatch("startLoading");
      try {
        // Query Data
        let response = (await Services.getPreRegisteredCommuters(
          this.queryParams
        )).data;

        // Assign the reponse data to items to be display on table
        this.items = response.data;

        // Assign Total number of data
        this.totalItems = response.count;

        // Assign Number started the data
        this.itemFrom = this.totalItems > 0 ? this.queryParams.offset + 1 : 0;

        // Assign Number end the data
        this.itemTo = this.queryParams.offset + this.queryParams.limit;

        if (this.totalItems <= this.itemTo) {
          this.itemTo = this.totalItems;
        }

        // Conditions for NextPage Button
        if (this.itemTo === this.totalItems) {
          this.disabledNext = true;
        } else {
          this.disabledNext = false;
        }
        // Conditions for BackPage Button
        if (this.itemFrom > 1) {
          this.disabledBack = false;
        } else {
          this.disabledBack = true;
        }
      } catch (error) {
        if (!error.response) {
          if (!this.$isEmpty(this.$store.state.employee)) {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          } else {
            this.$store.dispatch("dispatchUnauthorized", true);
          }
        } else {
          if (error.response.status === 403) {
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      this.$store.dispatch("endLoading");
    },
    async setData(id) {
      var data = {};

      try {
        const response = await Services.getPreRegisteredCommuter(id);

        data = await response.data;

        data.first_name = data.first_name.toUpperCase();
        data.middle_name = data.middle_name.toUpperCase();
        data.last_name = data.last_name.toUpperCase();
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      return data;
    },
    async setDuplicateData(id) {
      var data = {};

      try {
        const response = (await Services.getRegisteredCommuters(id)).data;

        data = await response.data;
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        } else {
          if (error.response.status === 403) {
            this.closeDialog();
            this.$store.dispatch("dispatchUnauthorized", true);
          } else {
            this.$infoBar({
              type: "error",
              text: "No network or server connection",
            });
          }
        }
      }
      return data;
    },

    async changeSort(column) {
      this.queryParams.offset = 0;
      if (this.queryParams.order === column.value) {
        column.sortNum++;
        if (column.sortNum === 1) {
          this.queryParams.desc = true;
        }
        if (column.sortNum === 2) {
          column.sortNum = 0;
          this.queryParams.desc = false;
          this.queryParams.order = "";
        }
      } else {
        this.queryParams.order = column.value;
        this.queryParams.desc = false;
        column.sortNum = 0;
      }
      for (let i = 0; i < this.headers.length; i++) {
        if (this.headers[i].value === column.value) {
          this.headers[i].sortNum = column.sortNum;
        }
      }
      this.getData();
    },
    nextClick() {
      this.queryParams.offset += this.queryParams.limit;
      this.getData();
    },
    backClick() {
      this.queryParams.offset -= this.queryParams.limit;
      this.getData();
    },
    async limitClick() {
      this.queryParams.offset = 0;
      this.getData();
    },
    async openViewDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewData = await this.setData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },

    async openDuplicateDialog(data) {
      this.dialogLoading = true;

      this.duplicateDialog = true;

      this.duplicateData = await this.setDuplicateData(data.id);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },

    closeViewDialog() {
      this.viewData = {};
      this.$refs.form.reset();
      this.dialogStatus = false;
      this.duplicateDialog = false;
    },
    openApprove(item) {
      this.openConfirmDialog = true;
      this.buttonType = "approve";
      this.viewData.id = item.id;
    },
    openDisapprove(item) {
      this.openApprovalDialog = true;
      this.buttonType = "disapprove";
      this.viewData.id = item.id;
    },
    async approveCommuter() {
      this.confirmLoading = true;

      try {
        const response = await Services.approveCommuter(this.viewData.id);

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeConfirmDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Approve Complete!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    async disapproveCommuter() {
      this.confirmLoading = true;

      try {
        const response = await Services.disapproveCommuter(this.viewData.id, {
          type: this.disapproveOption,
        });

        if (
          response.status === 201 ||
          response.status === 204 ||
          response.status === 200
        ) {
          this.closeConfirmDialog();
          await this.getData();
          this.$infoBar({
            type: "success",
            text: "Disapprove Complete!",
          });
        } else {
          this.$infoBar({
            type: "error",
            text: "Server Error!",
          });
        }
      } catch (error) {
        if (!error.response) {
          this.$infoBar({
            type: "error",
            text: "No network or server connection",
          });
        }
      }
      this.confirmLoading = await false;
    },
    closeConfirmDialog() {
      this.openConfirmDialog = false;
      this.openApprovalDialog = false;
    },
    async openFilterExpansion() {
      this.openFilter = await !this.openFilter;
    },
    async refreshTable() {
      this.getData();
    },
  },
};
</script>

<style scoped>
.scrolling-wrapper {
  overflow-x: hidden;
  width: 400px;
  height: 400px;
  overflow-y: scroll;
  white-space: nowrap;
}
</style>
